export default __webpack_public_path__ + "static/cashflow_new_17-efb4333ece3a49821c5e89a168ba1211.jpg";